import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from './fetchCountries.api';

export const useGetCountries = (includeUSA: boolean, allCountries?: boolean) =>
  useQuery({
    queryKey: ['countries', includeUSA, allCountries],
    queryFn: () => fetchCountries(includeUSA, allCountries),
    enabled: true,
    retry: false,
    staleTime: Infinity, // Prevents refetching until the data is considered stale
    refetchOnWindowFocus: false, // Prevents refetching when the window regains focus
  });
